import { createScope } from 'bunshi';

/** Scope for in-call video session state. Keyed by roomId. */
export const SessionScope = createScope<string | undefined>(undefined);

/** Scope for post-session charting state. Keyed by appointmentId. */
export const ChartingScope = createScope<string | undefined>(undefined);

/** Scope for appointment state. Keyed by dailyRoomName. */
export const DailyRoomNameScope = createScope<string | undefined>(undefined);
